import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '../src/assets/commun.css';
import axios from 'axios';

Vue.config.productionTip = false;
Vue.use(ElementUI);

// vuex@4 是给 Vue 3 用的：它的 install 走 app.provide / app.config.globalProperties，
// 在 Vue 2 下 Vue.use(Vuex) 是空操作，组件实例上不会挂载 $store，
// 于是在组件里 this.$store 为 undefined，调用 commit 就报
// "Cannot read properties of undefined (reading 'commit')"。这里手动挂载兜底。
// （若后续把 vuex 降到 3.x，本行无害，实例上的 $store 仍由 vuex 的 mixin 注入）
if (!Vue.prototype.$store) {
  Vue.prototype.$store = store
}

Vue.prototype.$axios = axios

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
